import { render, staticRenderFns } from "./DeviceIphone.vue?vue&type=template&id=0560a48c&"
import script from "./DeviceIphone.vue?vue&type=script&lang=js&"
export * from "./DeviceIphone.vue?vue&type=script&lang=js&"
import style0 from "./DeviceIphone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports